<div class="form-container">

  <form ngNoForm [formGroup]='resetPasswordForm' *ngIf="resetPasswordForm">

    <div class="flex-1 d-flex fd-row ai-center icons-container">
      <span class="material-icons border-circle ">construction</span>
      <span class="material-icons border-circle">train</span>
      <span class="material-icons border-circle">cases</span>
    </div>

    <p class="reset-password-heading">Reset Password</p>
    <p>Please choose a new password.</p>

    <mat-form-field class="new-password-container" appearance="outline">
      <mat-label>
        New password
      </mat-label>
      <input [type]="hide ? 'password' : 'text'" matInput type="password" formControlName="newPassword" type="password">
      <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" tabindex="-1" type="button">
        <mat-icon> {{hide ? 'visibility_off' : 'visibility'}} </mat-icon>
      </button>

      <mat-error *ngIf="resetPasswordForm.controls.newPassword.hasError('required')">
        Password is <strong>required</strong>
      </mat-error>
      <mat-error *ngIf="resetPasswordForm.controls.newPassword.hasError('pattern')">
        Passwords must be 8 characters and contain at least 1 lowercase, uppercase and numeric
        character.
      </mat-error>
    </mat-form-field>

    <mat-form-field class="confirm-password-container" appearance="outline">
      <mat-label>
        Confirm new password
      </mat-label>
      <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword" [errorStateMatcher]="matcher" type="password">
      <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword" tabindex="-1">
        <mat-icon> {{hideConfirmPassword ? 'visibility_off' : 'visibility'}} </mat-icon>
      </button>
      <mat-error *ngIf="resetPasswordForm?.hasError('notSame')">
        Passwords must match!
      </mat-error>
    </mat-form-field>

    <button mat-stroked-button color="primary" [disabled]="!resetPasswordForm.valid" (click)="onSubmit()">Reset password</button>
  </form>
</div>
